// Zsiska minimum quantity enforcement
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        const cartDrawer = document.querySelector('.cart-drawer, [data-cart-drawer], .drawer--cart');
        if (cartDrawer) {
          fixZsiskaQuantities();
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  fixZsiskaQuantities();
});

function fixZsiskaQuantities() {
  const quantityInputs = document.querySelectorAll('input[name*="updates"], input[data-quantity-input]');
  
  quantityInputs.forEach(input => {
    const row = input.closest('tr, .cart-item, .line-item');
    if (row && row.textContent.includes('Zsiska')) {
      if (input.value == '1') {
        input.value = '2';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}